import React from "react";
import { EmployeeInformationContainer } from "../../../containers";

const EmployeeInformation = (props) => {
  return <EmployeeInformationContainer {...props} />;
};

export default EmployeeInformation;
